import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { sellerInitialState } from 'v3/data/store/seller/state';
import {
  ISeller,
  ISellersList,
  IStoreList,
  IUploadSellerFileResponseData
} from 'v3/data/store/seller/types';

export const sellerSlice = createSlice({
  name: 'seller',
  initialState: sellerInitialState,
  reducers: {
    setSeller: (state, action: PayloadAction<ISeller>) => {
      state.seller = action.payload;
      return state;
    },
    setSellerId: (state, action: PayloadAction<string>) => {
      state.seller.id = action.payload;
      return state;
    },
    clearSeller: (state) => {
      state = sellerInitialState;
      return state;
    },
    setAllSellerList: (state, action: PayloadAction<ISellersList>) => {
      state.sellerList = action.payload;
      return state;
    },
    setSellersFilters: (state, action: PayloadAction<string>) => {
      state.sellersFilter.filter = action.payload;
      return state;
    },
    setSellerActive: (state, action: PayloadAction<boolean | null>) => {
      state.sellersFilter.active = action.payload;
      return state;
    },
    setFilterCurrentPage: (state, action: PayloadAction<number>) => {
      state.sellersFilter.page = action.payload;
      return state;
    },
    setFilterRowsPerPage: (state, action: PayloadAction<number>) => {
      state.sellersFilter.rowsPerPage = action.payload;
      return state;
    },
    clearSellerSelected: (state) => {
      state.seller = sellerInitialState.seller;
      return state;
    },
    setUploadSellerFileResponse: (state, action: PayloadAction<IUploadSellerFileResponseData>) => {
      state.uploadSellerFileResponse.data = action.payload;
      return state;
    },
    setSellerInvalidRowsModalOpen: (state, action: PayloadAction<boolean>) => {
      state.uploadSellerFileResponse.sellerInvalidRowsModalOpen = action.payload;
      return state;
    },
    setRemoveSeller: (state) => {
      state.seller = sellerInitialState.seller;
      return state;
    },
    setStoreList: (state, action: PayloadAction<IStoreList[]>) => {
      state.storeList = action.payload;
      return state;
    },
    setStoreIdsList: (state, action: PayloadAction<string[]>) => {
      state.sellersFilter.storeIds = action.payload;
      return state;
    },
  },
});
